<script lang="ts">
	import { onMount } from 'svelte';
	import { browser } from '$app/env';
	import * as CookieConsent from 'vanilla-cookieconsent';
	import { cookieConsentConfig } from '#lib/common/Infrastructure/CookieConsent/cookieConsentConfig.js';
	import 'vanilla-cookieconsent/dist/cookieconsent.css';
	import './cookieconsent-overrides.css';

	onMount(() => {
		if (browser) {
			CookieConsent.run(cookieConsentConfig);
		}
	});
</script>
